import React, { useEffect,useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StatusDropdown from './statusOptions';
import axios from 'axios';

const VendorCall = () => {

    const navigate = useNavigate();
     const [totalAmount, setTotalAmount] = useState(0);
            const [rechargeList, setRechargeList] = useState([])

    // ⬅ AUTO REDIRECT TO "new" PAGE
    useEffect(() => {
        navigate("/admin/crm/vendor-call/new");
    }, []);


   
        useEffect(() => {
            fetchRecharge();
        }, [])

  
    const fetchRecharge = async () => {
  try {
    const res = await axios.get('https://api.skyguard.group/api/fetch-recharge');

    setRechargeList(res.data);

    if (res.data.length > 0) {
      const latest = res.data[res.data.length - 1];
      setTotalAmount(Number(latest.totalAmount || 0));
   
    }

  } catch (error) {
    console.error(error);
  }
};

    

    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

                <h3 className='my-3 fw-bold fs-5 golos'>Vendor Call</h3>

                 <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-middle">

                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className="btn btn-primary">
                                Total Balance: ₹{totalAmount}
                            </button>
                        </div>


                    </div>

                <div className="row gx-3 gy-2">

                    <div className="col-md-4">
                        <label className="form-label fw-medium">Search</label>
                        <input
                            type="text"
                            className="form-control border-0 border-bottom border-dark"
                            placeholder="Search..."
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-medium">Select Status</label>
                        <StatusDropdown current={"new"} />
                    </div>

                </div>

            </div>
        </div>
    );
};

export default VendorCall;
